import {useEffect, useState} from "react";
import { Button, Modal } from 'antd';
import CrmProductForm from './CrmProductForm.js';
import {setProductDataAction} from "../store/actions/productActions";
import {useDispatch, useSelector} from "react-redux";

function CrmProductModal(props) {


    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {

        setIsModalOpen(true);
        dispatch(setProductDataAction(false));
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        console.log(props.rand)
        if (props.id) {
            setIsModalOpen(true)
        }
    }, [props.rand])

    return (
        <>
            <Button type="primary" onClick={showModal}>Add product</Button>

            <Modal title="Product"
                   open={isModalOpen}
                   onOk={handleOk}
                   onCancel={handleCancel}
                   width={1500}
            >
                <CrmProductForm />
                {/* <CrmProductForm id={props.id}  rand={Math.random(1,10)}/> */}
            </Modal>
        </>
    );
}
export default CrmProductModal;
